import { createSlice } from '@reduxjs/toolkit';

export const Incentive = createSlice({
  name: 'IncentiveDetails',
  initialState: {
    message: '',
    referenceId: '',
    status: '',
    hipaaConsent: '',
    subscriptionFlag: '',
  },
  reducers: {
    SetIncentiveDetails: (state, action) => {
      state.message = action.payload.message;
      state.referenceId = action.payload.referenceId;
      state.status = action.payload.status;
      state.hipaaConsent = action.payload.hipaaConsent;
      state.subscriptionFlag = action.payload.subscriptionFlag;
    },
  },
});
export const { SetIncentiveDetails } = Incentive.actions;
export const selectRefId = (state) => state.IncentiveDetails.referenceId;
export const selectSubscriptionFlag = (state) =>
  state.IncentiveDetails.subscriptionFlag;

export default Incentive.reducer;
